import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Observable, of, catchError, take, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { profileRouteNavigator } from '../helpers/profileRouteNavigator.helpers';
import { UserRole } from '../constants/keys.constant';
import { ProfileStepsCompleted } from '../constants/signUpStepper.const';

export const profileResolver: ResolveFn<any> = (route, state): Observable<any> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (!authService.currentProfileDetails) {
    if (localStorage.getItem(environment.storageKey)) {
      return authService.getProfile().pipe(
        take(1),
        tap((profile) => {
          if (profile) {
            authService.profileDetailsSubject.next(profile);
            if ((profile.role === UserRole.TUTOR || profile.role === UserRole.COUNSELOR) && (profile.profileStepsCompleted === ProfileStepsCompleted.TutorCounsellorAvailabilityDone || profile.profileStepsCompleted === ProfileStepsCompleted.TutorCounsellorProfileDone)) {
              if (!state.url.includes('/tutor')) {
                if (!state.url.includes('manage-session')) {
                  router.navigate(['/tutor/dashboard']);
                }
              }
            } else {
              if (state.url === '/auth/login?isIFrame=true' || state.url === '/auth/signup?isIFrame=true') {
                return;
              }
              profileRouteNavigator(profile, router, state.url);
            }
          }
        }),
        catchError((error) => {
          console.error('Error fetching profile:', error);
          return of(null);
        })
      );
    } 
    // else if (route.queryParamMap.get('isIFrame') === 'true') {
    //   router.navigateByUrl('/auth/signup?isIFrame=true');
    //   return of(null);
    // }
  }

  // Return cached profile as an observable
  return authService.profileDetailsSubject.asObservable();
};
